export default __webpack_public_path__ + "static/triplelayer-55dc39d95b22a301b20d98dd2b68a776.png";